import getEnvFromLocation from 'utils/getEnvFromLocation'

import { ZAI_CHAT_URL_BY_ENVIRONMENT } from './consts'

class ZaiChatService {
  public baseUrl: string

  constructor() {
    this.baseUrl = this.getBaseURLByEnvironment()
  }

  private getBaseURLByEnvironment() {
    const environment = getEnvFromLocation()

    return ZAI_CHAT_URL_BY_ENVIRONMENT[environment] || ZAI_CHAT_URL_BY_ENVIRONMENT.development
  }
}

export const zaiChatService = new ZaiChatService()
